export default {
    top_menu: [
        {name:'Główna rzecz',    id:0},
        {name:'pokazać Biznes', id:1},
        {name:'Gotowanie',  id:2},
        {name:'Polityka',   id:3},
        {name:'+18',  id:4},
        {name:'Społeczeństwo',   id:5},
        {name:'Zdrowie',   id:6},
    ],
    read_other: 'Czytaj więcej',
    read_more:  'Więcej szczegółów',
    not_found:  'Nic nie znaleziono',
    read_also:  'Przeczytaj także',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Wszelkie prawa zastrzeżone.',
    subscribe: 'Subskrybuj',

    thank_order: 'DZIĘKUJEMY ZA ZAMÓWIENIE',
    specialist_contact: 'Nasz specjalista wkrótce się z Tobą skontaktuje, poczekaj na nasz telefon.',
    attention: 'Zniżki od partnerów:',
    hurry: 'Pospiesz się, czas aktywacji zniżki jest ograniczony! Masz tylko <span id="time" class="time">30:00</span> minut, aby wybrać jeden z tych wyjątkowych produktów:',

    hour_ago1: "Godzinę temu",
    hour_ago2: "godzinę temu",
    hour_ago3: "godzinę temu",
    new_publications: "Nowe publikacje",
    read: "Czytać",
    today_at: "Dzisiaj o",
    author_names: ['Fryderyk Chopin','Krzysztof Penderecki','Stanisław Moniuszko'],
    main_news: "Główne wiadomości",
    leave_already: "Już wyjeżdżasz? Czekaj, zaktualizowaliśmy dla Ciebie wiadomości",
    already_shared: "już udostępniony"

}